// Кто пишет в общий чат из этого приложения — id курьера из access-токена (sub).
// Токен приходит при входе, поэтому «свои» сообщения узнаются сразу, без /me.

import { useAuthStore } from '@/store/auth';

function subOf(token: string | null): string {
  if (!token) return '';
  try {
    const payload = token.split('.')[1] ?? '';
    const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    return (JSON.parse(json) as { sub?: string }).sub ?? '';
  } catch {
    return '';
  }
}

export function useChatMe(): string {
  return subOf(useAuthStore((s) => s.accessToken));
}

export function getChatMeId(): string {
  return subOf(useAuthStore.getState().accessToken);
}
